export default __webpack_public_path__ + "static/banner-bg-4e24a101f614319ae161cae21fe3832b.webp";